module.exports = __webpack_public_path__ + "img/star.bcd34041.svg";